import { useState, useEffect } from 'react';

const useFullscreen = (containerRef) => {
    const [isFullscreen, setIsFullscreen] = useState(false);
    const [fullscreenError, setFullscreenError] = useState(false);

    useEffect(() => {
        const handleFullscreenChange = () => {
            setIsFullscreen(!!document.fullscreenElement);
        };

        document.addEventListener('fullscreenchange', handleFullscreenChange);
        document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
        document.addEventListener('msfullscreenchange', handleFullscreenChange);

        return () => {
            document.removeEventListener('fullscreenchange', handleFullscreenChange);
            document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
            document.removeEventListener('msfullscreenchange', handleFullscreenChange);
        };
    }, []);

    const handleEnterFullscreen = async () => {
        if (!containerRef.current) return;

        try {
            if (containerRef.current.requestFullscreen) {
                await containerRef.current.requestFullscreen();
            } else if (containerRef.current.webkitRequestFullscreen) {
                await containerRef.current.webkitRequestFullscreen();
            } else if (containerRef.current.msRequestFullscreen) {
                await containerRef.current.msRequestFullscreen();
            }
            setIsFullscreen(true);
            setFullscreenError(false);
        } catch (error) {
            console.error('Fullscreen error:', error);
            setFullscreenError(true);
            // Continue recording even if fullscreen fails
            setIsFullscreen(false);
        }
    };

    const handleExitFullscreen = () => {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
        setIsFullscreen(false);
    };

    return {
        isFullscreen,
        fullscreenError,
        handleEnterFullscreen,
        handleExitFullscreen
    };
};

export default useFullscreen;